import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track"];
  static values = {
    speed: { type: Number, default: 50 }, // pixels per second
  };

  connect() {
    this.calculateAndAnimate();

    // Recalculate on window resize
    this.resizeObserver = new ResizeObserver(() => {
      this.calculateAndAnimate();
    });
    this.resizeObserver.observe(this.element);
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  calculateAndAnimate() {
    // Wait for all images to load before calculating width
    const images = this.element.querySelectorAll("img");
    const imagePromises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    });

    Promise.all(imagePromises).then(() => {
      if (!this.hasTrackTarget || this.trackTargets.length === 0) return;

      // Get the width of the first track (one complete set)
      const firstTrack = this.trackTargets[0];
      const contentWidth = firstTrack.scrollWidth;

      // Calculate duration: width / speed
      const duration = contentWidth / this.speedValue;

      // Apply animation duration to all tracks
      this.trackTargets.forEach((track) => {
        track.style.animationDuration = `${duration}s`;
        track.style.animationPlayState = "running";
      });
    });
  }
}
